import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MainComponent } from '../components/main/main.component';
import { SchemasComponent } from '../components/schemas/schemas.component';
import { FooterComponent } from '../components/footer/footer.component';
import { InfoBannerComponent } from '../components/info-banner/info-banner.component';
import { HeaderComponent } from '../components/header/header.component';
import { FaqComponent } from '../components/faq/faq.component';
import { BenefitsComponent } from '../components/benefits/benefits.component';
import { CtaComponent } from '../components/cta/cta.component';

@Component({
  selector: 'rp-home-landing',
  standalone: true,
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MainComponent,
    SchemasComponent,
    FooterComponent,
    InfoBannerComponent,
    HeaderComponent,
    FaqComponent,
    BenefitsComponent,
    CtaComponent,
  ],
})
export class LandingComponent {}
